import {
  DEALSTATUS_LOADING,
  GET_DEALSTATUS,
  GET_DEALSTATUS_SUCCESS,
  GET_DEALSTATUS_FAIL,
  ADD_DEALSTATUS_SUCCESS,
  ADD_DEALSTATUS_FAIL,
  DELETE_DEALSTATUS_SUCCESS,
  DELETE_DEALSTATUS_FAIL,
  UPDATE_DEALSTATUS_SUCCESS,
  UPDATE_DEALSTATUS_FAIL,
  DEALSTATUS_RESET,
} from "./actionType";

const INIT_STATE = {
  dealStatus: [],
  error: {},
};

const DealStatus = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_DEALSTATUS_SUCCESS:
      switch (action.payload.actionType) {
        case GET_DEALSTATUS:
          return {
            ...state,
            dealStatus: action.payload.data,
            isDealStatusCreated: false,
            isDealStatusSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_DEALSTATUS_FAIL:
      switch (action.payload.actionType) {
        case GET_DEALSTATUS_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isDealStatusCreated: false,
            isDealStatusSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_DEALSTATUS: {
      return {
        ...state,
        isDealStatusCreated: false,
        loading: true,
      };
    }

    case DEALSTATUS_LOADING: {
      return {
        ...state,
        isDealStatusCreated: false,
        loading: true,
      };
    }

    case ADD_DEALSTATUS_SUCCESS:
      return {
        ...state,
        isDealStatusCreated: true,
        loading: false,
        dealStatus: [action.payload.data, ...state.dealStatus],
      };

    case ADD_DEALSTATUS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_DEALSTATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        isDealStatusCreated: true,
        dealStatus: state.dealStatus.filter(
          (dealStatus) =>
            dealStatus.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_DEALSTATUS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_DEALSTATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        isDealStatusCreated: true,
        dealStatus: state.dealStatus.map((dealStatus) =>
          dealStatus.id.toString() === action.payload.data.id.toString()
            ? { ...dealStatus, ...action.payload.data }
            : dealStatus
        ),
      };

    case UPDATE_DEALSTATUS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DEALSTATUS_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default DealStatus;
